"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var classnames_1 = tslib_1.__importDefault(require("classnames"));

var Input_1 = require("@skbkontur/react-ui/components/Input");

var Sticky_1 = require("@skbkontur/react-ui/components/Sticky");

var _debounce = require("lodash/debounce");

var Search_module_css_1 = tslib_1.__importDefault(require("./Search.module.css"));

var Parameters_1 = require("../../Control/Parameters");

var Search =
/** @class */
function (_super) {
  tslib_1.__extends(Search, _super);

  function Search() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      searchValue: ''
    };
    _this.oldPassedSearchValue = '';
    _this.delayedOnChange = _debounce(function (newSearchValue) {
      newSearchValue = newSearchValue.trim();

      if (newSearchValue === _this.oldPassedSearchValue) {
        return;
      }

      _this.oldPassedSearchValue = newSearchValue;

      _this.props.onChange(newSearchValue);
    }, 200);

    _this.onValueChange = function (searchValue) {
      _this.setState({
        searchValue: searchValue
      });

      _this.delayedOnChange(searchValue);
    };

    return _this;
  }

  Search.prototype.render = function () {
    var _a;

    var searchValue = this.state.searchValue;
    var _b = this.props,
        offset = _b.offset,
        view = _b.view;
    var searchClassName = classnames_1.default((_a = {}, _a[Search_module_css_1.default.search] = true, _a[Search_module_css_1.default.modal] = view === Parameters_1.CertificatesListView.Modal, _a));
    return react_1.default.createElement(Sticky_1.Sticky, {
      side: "top",
      offset: offset
    }, react_1.default.createElement("div", {
      className: searchClassName
    }, react_1.default.createElement(Input_1.Input, {
      placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430\u043C",
      autoFocus: true,
      value: searchValue,
      onValueChange: this.onValueChange,
      width: '100%'
    })));
  };

  Search.defaultProps = {
    offset: 0
  };
  return Search;
}(react_1.default.Component);

exports.Search = Search;